import { applySnapshot, types } from "mobx-state-tree";
import customtypes from "../../utils/mobx-types-helper";

const SelectListModel = types
    .model("SelectListModel", {
        id: customtypes.optional(types.number, 0),
        code: customtypes.optional(types.string, ""),
        description: customtypes.optional(types.string, ""),
        isSelected: customtypes.optional(types.boolean, false),
    })
    .views((self: any) => ({
        get dropdownOption() {
            return {
                id: self.id,
                text: self.description,
                value: self.code,
            };
        },
        get orgDropdownOption() {
            return {
                text: self.description,
                value: self.id,
            };
        },
    }))
    .actions((self: any) => ({
        setField: (id: number, code: string, value: string) => {
            self.id = id;
            self.code = code;
            self.description = value;
            self.isSelected = true;
        },
        resetAll: () => {
            applySnapshot(self, {});
        },
    }));

export type ISelectListModel = typeof SelectListModel.Type;
export default SelectListModel;
